module.exports = __webpack_public_path__ + "img/9788996559900.7f103041.jpg";